import { createContext } from "react";

const ContextProduct = createContext();

export default ContextProduct;
